// eslint-disable-next-line import/prefer-default-export
export const Fields = [
  {
    type: 'select',
    id: 'type',
    label: 'Type client',
    listName: 'types',
    filter: (options, v) => options
      .filter((option) => option?.toLowerCase().includes(v.inputValue.toLowerCase())),
    optionLabel: (option) => option,
  },
  {
    type: 'select',
    id: 'payment',
    label: 'Mode de règlement',
    listName: 'paymentModes',
    filter: (options, state) => options
      .filter((option) => option.name?.toLowerCase().includes(state.inputValue.toLowerCase())),
    optionLabel: (option) => option.name,
  },
  {
    type: 'select',
    id: 'expedition',
    label: 'Transport',
    listName: 'expeditions',
    filter: (options, state) => options
      .filter((option) => option.name?.toLowerCase().includes(state.inputValue.toLowerCase())),
    optionLabel: (option) => option.name,
  },
  {
    type: 'number',
    id: 'nbrReleveAuthorise',
    label: 'Nbr. relevés autorisés',
  },
  {
    type: 'number',
    id: 'encours',
    label: 'Encours max PM',
  },
  {
    type: 'number',
    id: 'encoursHuile',
    label: 'Encours max H',
  },
  {
    type: 'number',
    id: 'nbrJourEcheancePm',
    label: 'Échéance PM (jours)',
    disabled: (values) => (values.payment ? ['ESPECES'/* , 'E/C' */].includes(values.payment.name) : false),
  },
  {
    type: 'number',
    id: 'nbrJourEcheanceH',
    label: 'Échéance H (jours)',
    disabled: (values) => (values.payment ? ['ESPECES'/* , 'E/C' */].includes(values.payment.name) : false),
  },
  {
    type: 'number',
    id: 'montantAlertePm',
    label: 'Montants PM Alertes',
  },
  {
    type: 'number',
    id: 'montantAlerteH',
    label: 'Montants H Alertes',
  },
  {
    type: 'select',
    id: 'blocage',
    label: 'Blocage',
    listName: 'blockings',
    filter: (options, state) => options
      .filter((option) => option?.toLowerCase().includes(state.inputValue.toLowerCase())),
    optionLabel: (option) => option,
    // display: (value) => (value === true ? 'Manuel' : 'Automatique'),
  },
  {
    type: 'date',
    id: 'blocageTerme',
    label: 'Blocage à terme',
    disabled: (values) => values.blocage === 'Manuel',
  },
];
